
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {compose} from 'redux'
import {connect} from 'react-redux'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import withWidth, {isWidthUp} from '@material-ui/core/withWidth'
import {translate} from 'react-i18next'
import { cloneDeep, isEqual, isString } from 'lodash'
import * as actions from '../../../actionTypes'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import ArrowBack from '@material-ui/icons/ArrowBack'
import TranslationSection from './section/TranslationSection'
import Button from '@material-ui/core/Button'

const SESSION_TRANSLATION_SECTIONS = [
  {
    id: 1,
    title: 'Factors in',
    key: 'factors'
  },
  {
    id: 2,
    title: 'Options in',
    key: 'options'
  },
  {
    id: 3,
    title: 'Comments in',
    key: 'counselorComments'
  },
  {
    id: 4,
    key: 'userComments'
  }
]

const DEFAULT_TRAN_LANG = {
  langCode: 'en',
  langName: 'English'
}

const EMPTY_TRANSLATION = {
  counselorComments: '',
  factors: ['', '', '', '', '', '', '', '', '', ''],
  options: ['', ''],
  optionsResults: ['', '', ''],
  userComments: ''
}

const styles = theme => {
  const {palette, spacing, breakpoints} = theme
  return {
    loader: {
      textAlign: 'center'
    },
    textRight: {
      textAlign: 'right'
    },
    resetButton: {
      marginRight: `${spacing.unit}px`
    },
    wrapper: {
      margin: spacing.unit,
      position: 'relative',
    },

    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    navButton: {
      backgroundColor: '#fff',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      height: 65,
      width: '100%',
      '&.borderTop': {
        borderTop: `1px solid ${palette.action.disabledBackground}`
      }
    },  
    navButtonDivider: {
      borderLeftColor: palette.action.disabledBackground,
      borderStyle: 'solid',
      borderWidth: 0,
      [breakpoints.down('sm')]: {
        borderLeftWidth: 1
      }
    },
    navContainer: {
      maxHeight: 70,
      paddingBottom: 50,
      marginBottom: 50,
      marginTop: 65,
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
        marginTop: 0
      }
    }
  }
}

class TranslationContainer extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    let transLangCode = prevState.transLangCode
    let transLangName = prevState.transLangName
    let others = prevState.others|| cloneDeep(nextProps.others)

    if (!prevState.others && !!nextProps.others) {
      // Session contains translations default to first non session language
      if (Object.keys(nextProps.others).length > 0) {
        for (let translation of nextProps.sessionTranslations) {
          translation.languageCode = translation.languageCode.toLowerCase()
          if (translation.languageCode !== nextProps.sessionLangCode.toLowerCase()) {
            transLangName = translation.languageName
            transLangCode = translation.languageCode
            break
          }
        }
      // Session contains no translations default to English -- for now
      } else {
        others = {}
        transLangCode = DEFAULT_TRAN_LANG.langCode
        transLangName = DEFAULT_TRAN_LANG.langName
        others[transLangCode] = cloneDeep(EMPTY_TRANSLATION)
      }
    }

    return {
      others,
      transLangName,
      transLangCode
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      others: null,
      transLangCode: null,
      transLangName: null,
      redirect: false
    }
    this.props.navigator.hideNavigation()
 }

  componentDidMount() {
    if (!this.props.others && !this.props.original) {
      this.props.getTranslations(this.props.sessionId, this.props.sessionTranslations, this.props.sessionLangCode)
    }
  }

  handleChange = (e, index) => {
    const { transLangCode, others } = this.state
    let other = cloneDeep(others[transLangCode])

    if (index === undefined) {
      other[e.target.name] = e.target.value
    } else {
      other[e.target.name][index] = e.target.value
    }

    this.setState({
      others: {
        ...others,
        [transLangCode]: other
      }
    })
  }

  setTranslations = () => {
    const { transLangCode, transLangName, others } = this.state
    if (isEqual(others[transLangCode], this.props.others[transLangCode])) {
      return // Nothing changed do nothing
    }
    this.props.setTranslations(this.props.sessionId, transLangCode, transLangName, cloneDeep(others[transLangCode]))
  }

  resetTranslations = () => {
    const { transLangCode, others: stateOthers } = this.state
    const { sessionTranslations, others: propOthers } = this.props

    this.setState({ 
      others: {
        ...stateOthers,
        [transLangCode]: sessionTranslations.length > 1 ? cloneDeep(propOthers[transLangCode]) : cloneDeep(EMPTY_TRANSLATION)
      }
    })
  }

  hasData = () => {
    return (this.props.original && this.state.others) && (this.state.transLangName && this.state.transLangCode)
  }

  canSubmit = () => {
    const { original } = this.props
    const { others, transLangCode } = this.state
    let isDisabled

    for (let key in original) {
      if (isString(original[key])) {
        if (original[key].length > 0) {
          isDisabled = others[transLangCode][key].trim().length === 0
        }
        if (isDisabled) return isDisabled // Don't continue Looping
      } else if (Array.isArray(original[key])) {
        for (let i = 0; i < original[key].length; i++) {
          if (original[key][i].length > 0) {
            isDisabled = others[transLangCode][key][i].trim().length === 0
          }
          if (isDisabled) return isDisabled // Don't continue Looping
        }
      }
    }
    return isDisabled
  }

  redirectToReportPage = () => {
    this.setState({ redirect: true}, () => this.props.navigator.showNavigation())
  }

  render() {
    const { t, original, classes, settingTrans, sessionLangName, width } = this.props
    const { transLangCode, others, transLangName, redirect } = this.state

    if (redirect) return <Redirect to="/session/report" />

    return (
      <Grid
        alignContent="flex-start"
        className="counseling-session-page-container"
        container
        justify="center"
        spacing={16}
      >
        <Grid item xs={10}>
          <Typography variant="headline">{t('Translation')}</Typography>
        </Grid>
        <Grid item xs={10}>
          {!this.hasData() && (
            <div className={classes.loader}>
              <CircularProgress size={75} />
            </div>
          )}
          {this.hasData() && SESSION_TRANSLATION_SECTIONS.map(section => (
            <TranslationSection
              key={section.id}
              sectionKey={section.key}
              original={original[section.key]}
              translation={others[transLangCode][section.key]}
              originalHeader={section.title ? `${section.title} ${sessionLangName}` : null}
              otherHeader={section.title ? `${section.title} ${transLangName}` : null}
              onChange={this.handleChange}
            />
          ))}
        </Grid>
        {this.hasData() && (
          <Grid item xs={10} className={classes.textRight}>
            <Button 
              className={classes.resetButton}
              onClick={this.resetTranslations}
              disabled={settingTrans}
              variant="outlined" 
              color="primary">
              {t('Cancel Changes')}
            </Button>
            <Button
              onClick={this.setTranslations}
              variant="contained"
              color="primary"
              disabled={this.canSubmit() || settingTrans}
            >
              {t('Save')} {settingTrans && <CircularProgress size={24} className={classes.buttonProgress} />}        
            </Button>
          </Grid>
        )}
        <Grid
          container
          item
          className={classes.navContainer}
          xs={isWidthUp('sm', width) ? 9 : 12}
        >
          <Grid
            className={classes.navButtonDivider}
            item
            xs={12}
          >
            <Button
              className={`${classes.navButton} borderTop`}
              color="primary"
              onClick={this.redirectToReportPage}
            >
              <ArrowBack className={classes.iconLeft}/> {t('Results')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  sessionTranslations: state.counselingSession.counselingSessionData.translations,
  sessionId: state.counselingSession.sessionId,
  sessionLangCode: state.counselingSession.counselingSessionData.primaryLanguageCode,
  sessionLangName: state.counselingSession.counselingSessionData.primaryLanguageName,
  original: state.counselingSession.translations.original,
  others: state.counselingSession.translations.others,
  settingTrans: state.counselingSession.translations.setTransLoading
})

const mapDispatchToProps = dispatch => ({
  setTranslations(sessionId, langCode, langName, translations) {
    const action = {type: actions.SESSION_SET_TRANSLATION_INIT, payload: { sessionId, langCode, langName,translations }}
    dispatch(action)
  },
  getTranslations(sessionId, translations, sessionLangCode) {
    const action = { type: actions.REQUEST_SESSION_TRANSLATIONS, payload: { sessionId, translations, sessionLangCode }}
    dispatch(action)
  }
})


TranslationContainer.propTypes = {
  sessionTranslations: PropTypes.arrayOf(
    PropTypes.shape({
      languageCode: PropTypes.string,
      languageName: PropTypes.string
    })
  ),
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sessionLangCode: PropTypes.string,
  original: PropTypes.shape({
    counselorComments: PropTypes.string,
    factors: PropTypes.arrayOf(PropTypes.string)
  }),
  others: PropTypes.object
}


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withWidth(),
  translate()
)(TranslationContainer)



// WEBPACK FOOTER //
// ./src/components/counseling-session/translation/TranslationContainer.js